var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleModuleDashboard',{attrs:{"module-id":_vm.Modules.MENSAJES,"profile-id":_vm.Profiles.PERSONAL,"actions":_vm.actions}})}
var staticRenderFns = []

export { render, staticRenderFns }